
import { defineComponent, reactive, ref, Ref } from "vue";
import { ElMessage, FormRules } from "element-plus";
import { useRoute, useRouter } from "vue-router";
import { merchantResourceDto, roleInfo, roleUpdate, roleadd } from "../../../../api/SysAdmin";
export default defineComponent({
  setup() {
    const img = ref("/compontsimg/icon_plus.png");
    const title = ref("添加角色");
    const route = useRoute();
    const { roleNo } = route.query;
    const router = useRouter();
    const treeLoading = ref(false);
    const treeListIds = ref<any>([]);
    const treeIds = ref<any>([]);
    const treeRef: Ref = ref(null);
    const form = ref<{ roleName: string; roleInfo: string }>({
      roleName: "",
      roleInfo: "",
    });

    const defaultProps = ref({
      children: "children",
      label: "resourceName",
    });
    const dataTree = ref([]);
    const getMerchantResourceDto = () => {
      treeLoading.value = true;
      merchantResourceDto().then((res: any) => {
        if (res.code === 1) {
          dataTree.value = res.data.allRes;
        }
        treeLoading.value = false;
      });
    };
    const getRoleInfo = () => {
      if (roleNo) {
        treeLoading.value = true;
        roleInfo(roleNo as string).then((res) => {
          if (res.code === 1) {
            dataTree.value = res.data.resourceDto.allRes;
            form.value = res.data;
            res.data.resourceDto.selectedRes.forEach((item: any) => {
              if (item.preResourceNo != -1) {
                treeListIds.value.push(item.resourceNo);
              }
              treeIds.value.push(item.resourceNo);
            });
          }
          treeLoading.value = false;
        });
        title.value = "编辑角色";
      } else {
        getMerchantResourceDto();
      }
    };
    getRoleInfo();
    const checked1 = ref(false);
    const rules = reactive<FormRules>({
      roleName: [{ required: true, message: "请输入角色名称", trigger: "blur" }],
    });
    // 提交
    const submitFn = () => {
      const params = {
        resourceNos: treeIds.value,
        roleInfo: form.value.roleInfo,
        roleName: form.value.roleName,
        roleNo: roleNo,
      };
      if (!form.value.roleName) {
        ElMessage.error("请输入角色名称");
      } else if (!treeIds.value.length) {
        ElMessage.error("请选择菜单权限");
      } else {
        if (route.query.roleNo) {
          roleUpdate(params).then((res: any) => {
            if (res.code === 1) {
              ElMessage({
                message: (res.msg as string) || "操作成功",
                type: "success",
              });
              // router.push({ path: "/systemManage/RolePurview" });
              // let onRoleNo = JSON.parse(sessionStorage.getItem("userInfo") as string).roleNo;
              // let flag = treeIds.value.indexOf(13);
              // if (roleNo == onRoleNo) {
              //   if (flag == "-1") {
              //     router.push({ path: "/" });
              //   }
              // }
              router.go(-1);
              // window.location.reload();
            } else {
              ElMessage.error(res.msg);
            }
          });
        } else {
          roleadd(params).then((res: any) => {
            if (res.code === 1) {
              ElMessage({
                message: (res.msg as string) || "操作成功",
                type: "success",
              });
              // router.push({ path: "/systemManage/RolePurview" });
              // let onRoleNo = JSON.parse(sessionStorage.getItem("userInfo") as string).roleNo;
              // let flag = treeIds.value.indexOf(13);
              // if (roleNo == onRoleNo) {
              //   if (flag == "-1") {
              //     router.push({ path: "/" });
              //   }
              // }
              router.go(-1);
              // window.location.reload();
            } else {
              ElMessage.error(res.msg);
            }
          });
        }
      }
    };
    // const change = (val: boolean) => {
    //   console.log(val);
    //   checked1.value = val;
    //   indeterminate.value = false;
    //   console.log(checked1.value);
    //   if (checked1.value) {
    //     let str = ["Promotion activities", "Online activities", "Simple brand exposure", "Offline activities"];
    //     form.value.check = str;
    //   }
    //   if (!checked1.value) {
    //     form.value.check = [];
    //   }
    // };
    // const indeterminate = ref(false);
    // const change2 = () => {
    //   console.log(form.value.check);

    //   if (form.value.check.length == 4) {
    //     checked1.value = true;
    //     indeterminate.value = false;
    //   } else if (form.value.check.length > 0 && form.value.check.length < 4) {
    //     indeterminate.value = true;
    //   } else {
    //     checked1.value = false;
    //     indeterminate.value = false;
    //   }
    // };
    const cancelFn = () => {
      router.go(-1);
    };
    // tree点击
    const getCheckedNodes = () => {
      let res = treeRef.value.getCheckedNodes();
      let arr: any[] = [];
      res.forEach((item: any) => {
        arr.push(item.resourceNo);
      });
      let result = treeRef.value.getHalfCheckedKeys();
      treeIds.value = arr.concat(result);
    };
    return {
      img,
      title,
      form,
      treeRef,
      treeListIds,
      treeLoading,
      checked1,
      rules,
      submitFn,
      // change,
      // change2,
      // indeterminate,
      cancelFn,
      defaultProps,
      dataTree,
      getCheckedNodes,
    };
  },
});
